import { render, staticRenderFns } from "./template_group_select.vue?vue&type=template&id=4909f10e&"
import script from "./template_group_select.vue?vue&type=script&lang=js&"
export * from "./template_group_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports